import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {BruteForce} from "../BruteForce";
import {BruteForceGameMode} from "../server/BruteForceGameMode";
import {BruteForceScatterSymbol} from "../reels/BruteForceScatterSymbol";
import {BruteForceSymbol, BruteForceSymbolStates} from "../reels/BruteForceSymbol";
import {BruteForceSound} from "../sound/BruteForceSound";
import {SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";

export class BruteForceScatterWinPresentation implements SimplePresentation {
    name: string = "ScatterWinPresentation";
    private _scatterWintl: gsap.core.Timeline;

    shouldRun(): boolean {
        return BruteForce.model.gameData.mode === BruteForceGameMode.NORMAL && (BruteForce.model.gameData.nextMode === BruteForceGameMode.FREESPIN || BruteForce.model.gameData.nextMode === BruteForceGameMode.FREESPIN_SUPER);
    }

    start(controller: SimplePresentationRunnerController): void {
        this._scatterWintl = gsap.timeline();
        this._scatterWintl.add(() => controller.setSkipCallback(() => {
            this._scatterWintl.timeScale(1.2);
        }));
        this._scatterWintl.to(this, {duration: 0.1});


        if (BruteForce.model.gameData.betLineWins.length > 0) {
            BruteForce.betlineView.reset();
            for (let j = 0; j < 5; j++) {
                BruteForce.allreelsView.reelModels[j].updateBetlineSymbolPosition(j);
            }
        }
        BruteForce.allreelsView.reelModels.forEach((reelModel: SimpleReelModel, reelNo: number) => {
            for (let symNo: number = 0; symNo < 5; symNo++) {
                const sym: BruteForceSymbol = <BruteForceSymbol>BruteForce.allreelsView.reelModels[reelNo].getStopSymbolAt(symNo);
                this._scatterWintl.add(sym.setState(BruteForceSymbolStates.NORMAL), 0.1);
            }
        });

        this._scatterWintl.to(this, {duration: 0.5});
        this._scatterWintl.addLabel("playWin");


        BruteForce.model.scatterLandedPos.forEach((pos: number, reelID) => {
            if (pos > -1) {
                const scatterTl: gsap.core.Timeline = gsap.timeline();
                const scatterSym: BruteForceScatterSymbol = <BruteForceScatterSymbol>BruteForce.allreelsView.reelModels[reelID].getStopSymbolAt(pos);
                scatterTl.add(scatterSym.setState(BruteForceSymbolStates.WIN), 0);
                this._scatterWintl.add(scatterTl, "playWin");
            }
        });

        this._scatterWintl.add(() => {
            BruteForceSound.playTrack(BruteForceSound.SCATTER_WIN_HIGHLIGHT);
        }, 0.2);

        this._scatterWintl.to(this, {duration: 0.2});
        this._scatterWintl.add(() => {
            if (BruteForceSound.soundPlayer.fetchSoundPlayer(BruteForceSound.SCATTER_WIN_HIGHLIGHT)?.isPlaying) {
                BruteForceSound.stopSound(BruteForceSound.SCATTER_WIN_HIGHLIGHT);
            }
            controller.setSkipCallback();
            controller.finish();
        });

    }
}